import { DataHandlerMedia, Media, type Folder } from "luxedo-data"
import { get, writable } from "svelte/store"
import { FileSystemMedia } from "../../../modules/file-system/FileSystemMedia"
import { openMediaUploadOverlay } from "luxedo-comps"

import { closeOverlay } from "overlay"
import { getCurrentUser } from "../../../stores/UserStore.svelte"

type MediaLibraryCTX = {
	activeFolder: Folder
	path: Array<{ id: number; name: string }>
	filterSelection: {
		filter: string
		order: string
	}
}

export namespace MediaLibraryController {
	const libraryStore = writable<MediaLibraryCTX>({
		activeFolder: undefined,
		path: [],
		filterSelection: {
			filter: "Last Modified",
			order: "Descending",
		},
	})

	let onDirectoryUpdate: (media: Array<Media | Folder>) => void = () => {}

	export function setDirectoryUpdateListener(cb: (media: Array<Media | Folder>) => void) {
		onDirectoryUpdate = cb
		updateActiveDirectory(get(libraryStore).activeFolder.id)
	}

	export function openNewMediaOverlay() {
		const activeFolder = get(libraryStore).activeFolder
		openMediaUploadOverlay(activeFolder, async () => {
			await FileSystemMedia.refreshData()
			closeOverlay()
		})
	}

	export function subscribe(cb: (ctx: MediaLibraryCTX) => void) {
		return libraryStore.subscribe(cb)
	}

	/** Update the selected filter */
	export function updateFilterOptions(newFilterOptions: { filter: string; order: string }) {
		libraryStore.update((ctx) => {
			return {
				...ctx,
				filterSelection: newFilterOptions,
			}
		})
	}

	export function updateActiveDirectory(newFolderId: number) {
		const activeFolder = FileSystemMedia.useDirectory(newFolderId, onDirectoryUpdate)
		const path = FileSystemMedia.getFolderPath(activeFolder, true)
		libraryStore.update((ctx) => {
			return { ...ctx, activeFolder, path }
		})
	}
}
